import AutoComplete from "@CubeComponents/Mui_Form/AutoComplete";
import TextFieldComponent from "@CubeComponents/Mui_Form/TextFieldComponent";
import { t } from "@i18n";
import type { ObjectIdString } from "@Helpers/schemas/common.schema";

/**
 * The only two fields this dropdown needs from a role row. Kept minimal (rather than
 * `PortalProfileItem`) because the second caller — projects' ProjectGroups — passes project-role rows
 * whose `permissions` shape differs from the portal-profile schema's.
 */
type RoleOption = { id?: ObjectIdString; frontendName?: string };

interface RolesModalContentProps {
  /**
   * KNOWN BUG, preserved verbatim: the sole caller (Members.tsx `AssignRolesModalContent`) passes its
   * whole `updateGroupsData` payload object here, not a role id, so the `dataSource.find` below never
   * matches and the dropdown always renders empty even after a role is picked. The fix would be to pass
   * `bulkSelectedRole.data.roleId`.
   */
  value: unknown;
  dataSource?: RoleOption[];
  onChange: (args: { value?: ObjectIdString; itemData: RoleOption | null }) => void;
}

function RolesModalContent({ value, dataSource, onChange }: RolesModalContentProps) {
  return (
    <div className="flex flex-col gap-5 pb-2">
      <div className="flex items-center gap-5 p-5 pb-0">
        <div className="text-lg font-semibold text-[var(--primary-text)]" data-testid="selectSingleRoleToAll">
          {t("Select a single role for selected users")}
        </div>
      </div>

      <div className="flex h-20 items-center gap-10 border-px border-[var(--button-light)] ps-10">
        <div className="text-lg font-semibold text-[var(--primary-text)]" data-testid="role">
          {t("Role")}
        </div>
        <AutoComplete
          options={dataSource || []}
          valueField="id"
          getOptionLabel={(option) => option.frontendName || ""}
          value={dataSource?.find((opt) => opt.id === value) || null}
          onChange={(_event, newValue) => onChange({ value: newValue?.id, itemData: newValue })}
          sx={{ width: "8.75rem" }}
          renderInput={(params) => <TextFieldComponent {...params} placeholder={t("Select Role")} />}
          data-testid="selectRoleInBulkUpdate"
        />
      </div>
    </div>
  );
}

export default RolesModalContent;
